import {
  Embedder,
  SiteItem,
  SitesInDetailsParameters,
  TrackingEventType,
} from "@vviinn/user-managment-client-ts";

import {
  AIMethodsTitles,
  SimilarityTitles,
  ColorTitles,
  EmbedderConfig,
} from "./types";

import {
  minimalTextTitleColor,
  minimalTextTitleSimilarity,
  netTextSurrounding,
  keysWithTitles,
} from "../helpers";
import { embedderTitleToAiTitle } from "./helpers/embedderTitleToAiTitle";

export const defaultSitesInDetailsParameters: SitesInDetailsParameters = {
  campaigns: true,
  track: true,
  assets: false,
};

const titleTextSurrounding = ["include", "Features", ...netTextSurrounding];

export const switchableSimilarityTitles: SimilarityTitles = {
  ...keysWithTitles(minimalTextTitleSimilarity, ...titleTextSurrounding),
};

export const switchableColorTitles: ColorTitles = {
  ...keysWithTitles(minimalTextTitleColor, ...titleTextSurrounding),
};
export const switchableSiteTitles: AIMethodsTitles = {
  ...switchableSimilarityTitles,
  ...switchableColorTitles,
};

export const callableNetFeatures = Object.keys(
  switchableSiteTitles,
) as (keyof SiteItem)[];

export const trackingEventTypes: TrackingEventType[] = [
  "product_load",
  "product_view",
  "product_click",
  "widget",
  "filter",
  "search",
];

export const embedderTitles: Embedder[] = [
  "kiba",
  "berry_punch",
  "darjeeling_second_flush",
  "volcanic_water",
];

export const defaultAiMethods: Embedder[] = [
  "berry_punch",
  "darjeeling_second_flush",
  "kiba",
];

export const defaultSegmentations: Embedder[] = ["kiba"];

export const defaultInitEmbedderConfig: EmbedderConfig[] = embedderTitles.map(
  (title) => ({
    active: !!defaultAiMethods.find((item) => item === title),
    useSegmentation: !!defaultSegmentations.find((item) => item === title),
    aiTitle: embedderTitleToAiTitle(title),
    name: title,
  }),
);
